import { render, staticRenderFns } from "./CourseElectiveSearchAutoComplete.vue?vue&type=template&id=2b06e587"
import script from "./CourseElectiveSearchAutoComplete.vue?vue&type=script&lang=js"
export * from "./CourseElectiveSearchAutoComplete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports